import { Client, ErrorEvent } from 'irc-framework';
import { IRC_EVENT, IRCMessageType } from '#/types/types';
import ConnectionHandler from '#/connectionHandler';
import TabManager from '#/ui/tabManager';
import MessageHandler from '#/messageHandler';

export class IrcErrorEventListener {
    private cH: ConnectionHandler;
    private client: Client;
    private tM: TabManager;
    private mH: MessageHandler;

    constructor(connectionHandler: ConnectionHandler) {
        this.cH = connectionHandler as ConnectionHandler;
        this.client = connectionHandler.client as Client;
        this.tM = connectionHandler.tabManager as TabManager;
        this.mH = connectionHandler.messageHandler as MessageHandler;
        this.setup();
    }

    private setup(): void {
        this.client.on(IRC_EVENT.IRC_ERROR, (event: ErrorEvent) => {
            const { error, from, to, nick, reason, channel, server, command } = event;
            let errorMessage = '';
            switch (error) {
                case 'irc':
                    errorMessage = `Unknown IRC Error: ${reason || 'No reason provided'}`;
                    break;
                case 'password_mismatch':
                    errorMessage = 'Password mismatch error';
                    break;
                case 'channel_redirect':
                    errorMessage = `Channel ${from} redirects to ${to}`;
                    //TODO JOIN NEW CHANNEL
                    break;
                case 'no_such_nick':
                    errorMessage = `No such nick: ${nick} (${reason})`;
                    break;
                case 'no_such_server':
                    errorMessage = `No such server: ${server} (${reason})`;
                    break;
                case 'cannot_send_to_channel':
                    errorMessage = `Cannot send to channel ${channel} (${reason})`;
                    break;
                case 'cannot_send_to_user':
                    errorMessage = `Cannot send to user ${nick} (${reason})`;
                    break;
                case 'too_many_channels':
                    errorMessage = `Cannot join ${channel} (${reason}), too many channels joined`;
                    break;
                case 'not_on_channel':
                    errorMessage = `You are not on channel ${channel} (${reason})`;
                    break;
                case 'user_on_channel':
                    errorMessage = `User ${nick} is already on channel ${channel}`;
                    break;
                case 'channel_is_full':
                    errorMessage = `Channel ${channel} is full (${reason})`;
                    break;
                case 'invite_only_channel':
                    errorMessage = `Channel ${channel} is invite only (${reason})`;
                    break;
                case 'banned_from_channel':
                    errorMessage = `You are banned from channel ${channel} (${reason})`;
                    break;
                case 'bad_channel_key':
                    errorMessage = `Incorrect key for channel ${channel} (${reason})`;
                    break;
                case 'chanop_privs_needed':
                    errorMessage = `You need to be a channel operator to perform that action on ${channel} (${reason})`;
                    break;
                case 'unknown_command':
                    errorMessage = `Unknown command "${command}" (${reason})`;
                    break;
                case 'banned_from_network':
                    errorMessage = `You are banned from this network (${reason})`;
                    break;
                case 'monitor_list_full':
                    errorMessage = `Monitor list is full (${reason})`;
                    break;
                default:
                    errorMessage = `Other Error: ${error}`;
                    break;
            }
            this.mH.addMessage(this.tM.getStatusTab(), errorMessage, IRCMessageType.ERROR);
        });
    }
}